import React, { useState } from "react";
import {
  SFStack,
  SFTypography,
  SFUseStyled,
  SFIconButton,
  SFIcons,
} from "@sf-core";
import Levels from "./levels";

const { styled } = SFUseStyled();

const SFIconButtonStyled = styled(SFIconButton, {
  shouldForwardProp: (prop) => prop !== "hasHover" && prop !== "hovered",
})(({ theme, hasHover, hovered }) => ({
  visibility: hasHover ? "hidden" : "visible",
  ...(hovered && {
    visibility: "visible",
  }),
}));

const STyledStack = styled(SFStack, {
  shouldForwardProp: (prop) => prop !== "hasHover" && prop !== "isSelected",
})(({ theme, hasHover, isSelected }) => ({
  borderRadius: theme.spacing(0.5),
  background: "rgba(235, 235, 227, 0.03)",
  border: "1px solid rgba(68, 68, 84, 1)",
  padding: theme.spacing(1.5),
  paddingBottom: theme.spacing(1),
  marginRight: theme.spacing(1) + "!important",
  marginBottom: theme.spacing(1),
  minWidth: "400px",
  ...(hasHover && {
    background: "rgba(235, 235, 227, 0)",
    "&:hover": {
      background: "rgba(235, 235, 227, 0.03)",
    },
  }),
  ...(isSelected && {
    border: "1px solid rgba(53, 164, 232, 0.6)",
  }),
}));

const StyledTypography = styled(SFTypography)(({ theme }) => ({
  color: theme.palette.grey400.main,
}));

const StyledContentStack = styled(SFStack)(({ theme }) => ({
  paddingTop: theme.spacing(0.5),
}));

const StepRowCard = ({
  rowId = "",
  title,
  description,
  onInfoClicked = () => {},
  hasHover = false,
  hasRadio = false,
  isSelected = false,
  onSelect = () => {},
  hasDelete = false,
  onDelete = () => {},
  hasLevels = false,
  level,
  setLevel,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <STyledStack
      direction="row"
      justifyContent="space-between"
      spacing={2}
      hasHover={hasHover}
      isSelected={isSelected}
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <SFStack direction="row">
        {hasRadio && (
          <SFIconButton variant="transparent" onClick={() => onSelect(rowId)}>
            {isSelected ? (
              <SFIcons.SFCheckCircleIcon color="blue300" />
            ) : (
              <SFIcons.SFRadioButtonUncheckedIcon color="grey300" />
            )}
          </SFIconButton>
        )}
        <StyledContentStack direction="column">
          <SFTypography variant={"body1"}>{title}</SFTypography>
          <StyledTypography variant={"body1"}>{description}</StyledTypography>
        </StyledContentStack>
      </SFStack>
      <SFStack direction="row">
        {hasLevels && <Levels level={level} setLevel={setLevel} />}
        <SFIconButtonStyled
          variant="transparent"
          hasHover={hasHover}
          hovered={hovered}
          onClick={() => onInfoClicked()}
        >
          <SFIcons.SFInfoIcon />
        </SFIconButtonStyled>
        {hasDelete && (
          <SFIconButtonStyled
            variant="transparent"
            hasHover={hasHover}
            hovered={hovered}
            onClick={() => onDelete()}
          >
            <SFIcons.SFRemoveCircleIcon color="red300" />
          </SFIconButtonStyled>
        )}
      </SFStack>
    </STyledStack>
  );
};

export default StepRowCard;
